import React from 'react';
import IbBrokerageOrderForm from 'Components/Banking/IbBrokerageOrderForm';
import './Brokerage.css';

// Kauf eines neuen Wertpapiers ueber IB direkt aus der Watchlist heraus
// (Chat vom 2026-08-07) - Pendant zu BrokerageBuyFromWatchlist.js (Comdirect),
// aber ohne Instrument-/Depot-Abgleich: IB braucht kein vorheriges
// reconcileWatchlist(), der Kontrakt wird einfach aus Symbol+Boersen-Suffix
// gebaut (siehe MarketdataQuotes.js::IB_STOCK_EXCHANGE, exakt dieselbe
// Zuordnung wie serverseitig in marketdataWorker.mjs::buildIbContracts() -
// bewusst gespiegelt statt per Request nachgeladen, da sich die Zuordnung
// nur bei einer neuen Boerse aendert).
export default function IbBrokerageBuyFromWatchlist({ x, symbol, label, price, bid, ask, contract, onClose }) {
	return (
		<div className="brokerage-overlay">
			<IbBrokerageOrderForm
				x={x}
				// label/price (Chat vom 2026-08-07) - fuer die Dialog-Ueberschrift
				// (voller Name statt nur des ggf. kryptischen IB-Symbols) und die
				// Limit-Preis-Vorbelegung. quoteSymbol/bid/ask (Chat vom
				// 2026-08-10) - internes Watchlist-Symbol fuer das Realtime-Bid/
				// Ask-Abo + Startwerte, siehe IbBrokerageOrderForm.js.
				target={{ ...contract, action: 'BUY', label, price, quoteSymbol: symbol, bid, ask }}
				onCancel={onClose}
				onDone={onClose}
			/>
		</div>
	);
}
